<script lang="ts">
  import { isNonEmptyArray } from '#app/lib/boolean_tests'
  import Link from '#app/lib/components/link.svelte'
  import { getTruthy } from '#app/lib/utils'
  import { getWikisourceData } from '#app/lib/wikimedia/sitelinks'
  import { formatEbooksClaim } from '#entities/components/lib/claims_helpers'
  import type { SerializedEntity } from '#entities/lib/entities'
  import type { PropertyUri } from '#server/types/entity'
  import { getCurrentLang, i18n, I18n } from '#user/lib/i18n'

  const {
    entity,
  }: {
    entity: SerializedEntity
  } = $props()

  const userLang = getCurrentLang()
  let ebooksData = $state([])

  function formatAndAssignEbooks (prop: PropertyUri) {
    const valuesData = formatEbooksClaim(entity.claims[prop], prop)
    if (valuesData) ebooksData = [ ...ebooksData, ...valuesData ]
  }

  formatAndAssignEbooks('wdt:P2034')
  formatAndAssignEbooks('wdt:P724')
  formatAndAssignEbooks('wdt:P4258')

  const wikisourceLink = $derived(getWikisourceData(getTruthy(entity, 'sitelinks'), userLang, entity.originalLang))
</script>

{#if isNonEmptyArray(ebooksData) || wikisourceLink}
  <div class="ebooks">
    <span>{I18n('ebooks')}:</span>
    {#each ebooksData as value (value.url)}
      <Link
        url={value.url}
        html={value.text}
      />
    {/each}
    {#if wikisourceLink}
      <Link
        url={wikisourceLink.url}
        text={`${i18n('on Wikisource')} (${wikisourceLink.lang})`}
        icon="wikisource"
      />
    {/if}
  </div>
{/if}

<style lang="scss">
  @import "general/scss/utils";
  .ebooks{
    @include display-flex(row, center, flex-start, wrap);
    color: $label-grey;
    :global(.icon){
      margin-inline: 0.6em 0.4em;
    }
    :global(a){
      @include link-dark;
    }
  }
</style>
